import React, { useCallback, useEffect, useMemo, useState } from "react";
import { connect } from "react-redux";
import muroStyles from "./ProfileMuro.module.scss";
import { feedService } from "../../../../services/feedService.ts";
import type { FeedPost } from "../../../../types/feed.ts";
import FeedCard from "../../../Dashboard/Feed/FeedCard.tsx";
import RegisteredUserProfileLoader from "../../../RegisteredUsers/RegisteredUsersSkeleton/RegisteredUserProfileLoader";
import ProfileEmptyState from "../ProfileEmptyState/ProfileEmptyState.tsx";

interface ProfileMuroOwnProps {
  myPerson: boolean;
  perfilAjeno?: string | number;
  userData: any;
  profileVisualizerData: any;
  setInfoReady: (ready: boolean) => void;
  refreshToken?: number;
}

interface ProfileMuroStateProps {
  sessionUser: any;
}

type ProfileMuroProps = ProfileMuroOwnProps & ProfileMuroStateProps;

const ProfileMuroInner: React.FC<ProfileMuroProps> = ({
  myPerson,
  perfilAjeno,
  userData,
  profileVisualizerData,
  setInfoReady,
  refreshToken = 0,
  sessionUser,
}) => {
  const [posts, setPosts] = useState<FeedPost[]>([]);
  const [loading, setLoading] = useState(true);

  const profileUserId = useMemo(() => {
    if (myPerson) return userData?.id;
    return profileVisualizerData?.id ?? perfilAjeno;
  }, [myPerson, userData?.id, profileVisualizerData?.id, perfilAjeno]);

  const loadPosts = useCallback(async () => {
    if (profileUserId == null || profileUserId === "") {
      setPosts([]);
      setLoading(false);
      setInfoReady(true);
      return;
    }
    setLoading(true);
    try {
      const data = await feedService.getOwnPosteos(profileUserId);
      setPosts(Array.isArray(data) ? data : []);
    } catch {
      setPosts([]);
    } finally {
      setLoading(false);
      setInfoReady(true);
    }
  }, [profileUserId, setInfoReady]);

  useEffect(() => {
    loadPosts();
  }, [loadPosts, refreshToken]);

  const myPosts = Boolean(
    myPerson &&
      sessionUser?.id != null &&
      profileUserId != null &&
      String(sessionUser.id) === String(profileUserId)
  );

  return (
    <>
      {loading ? (
        <div className={muroStyles.loadingContainer}>
          <RegisteredUserProfileLoader smallVersion={false} noBackground={false} />
        </div>
      ) : !posts.length ? (
        <ProfileEmptyState
          illustration="muro"
          title={myPerson ? "Tu muro está vacío" : "Este perfil no tiene publicaciones"}
          description={
            myPerson
              ? 'Usá "Nuevo post" arriba para compartir novedades, fotos o videos con quien visita tu perfil.'
              : "Cuando publique en su muro, las entradas van a mostrarse acá."
          }
        />
      ) : (
        <div className={muroStyles.list}>
          {posts.map((item) => (
            <FeedCard key={item.id} item={item} myPosts={myPosts} />
          ))}
        </div>
      )}
    </>
  );
};

const mapState = (state: { general?: { userData?: any } }) => ({
  sessionUser: state.general?.userData,
});

export default connect(mapState)(ProfileMuroInner);
